// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/base","visuallyHidden":"base-m__visuallyHidden__1AeWe","focusable":"base-m__focusable__1_qAN","hidden":"base-m__hidden__3QddU"};